/* corex-textil-editor-ui.js · HTML de los controles del personalizador de camisetas (funciones puras:
   reciben datos y devuelven cadenas ya escapadas). */
(function () {
  'use strict';

  var IO = window.CorexTextilIO;
  var M = window.CorexTextilModel;
  var esc = IO.esc, fmt = IO.fmt;
  /* alto por talla: siempre con un decimal (el ancho es entero) */
  function fmt1(v) { return (Math.round(v * 10) / 10).toFixed(1).replace('.', ','); }

  function colors(list, selected) {
    return list.map(function (c) {
      var on = c.name === selected;
      var sw = IO.swatchStyle(c), bg = sw.style ? ' style="' + sw.style + '"' : '';
      return '<button type="button" class="cte-sw' + (sw.light ? ' cte-sw--light' : '') + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on +
        '" aria-label="' + esc(c.name) + '" title="' + esc(c.name) + '" data-cte-color="' + esc(c.name) + '"' + bg + '></button>';
    }).join('');
  }

  function sizes(variants, selected, medidas) {
    return variants.map(function (v) {
      var on = v.talla === selected, known = !!medidas[v.talla], off = !v.available || !known;
      return '<button type="button" class="cte-size' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '"' +
        (off ? ' disabled title="' + (known ? 'Sin stock en este color' : 'Sin medidas') + '"' : '') +
        ' data-cte-size="' + esc(v.talla) + '">' + esc(v.talla) + '</button>';
    }).join('');
  }

  /* Tabla de medidas de la prenda. La manga estimada (manga_est: solo para dibujar la silueta) no se enseña. */
  function guide(order, medidas) {
    var val = function (s, k) { var m = medidas[s]; return k === 'manga' && m.manga_est ? null : m[k]; };
    var rows = [['Pecho (½)', 'pecho'], ['Largo total', 'largo'], ['Manga', 'manga']].filter(function (r) {
      return r[1] !== 'manga' || order.some(function (s) { return val(s, 'manga') != null; });
    });
    return '<table class="cte-table"><thead><tr><th scope="col">cm</th>' +
      order.map(function (s) { return '<th scope="col">' + esc(s) + '</th>'; }).join('') + '</tr></thead><tbody>' +
      rows.map(function (r) {
        return '<tr><th scope="row">' + r[0] + '</th>' + order.map(function (s) {
          var v = val(s, r[1]);
          return '<td>' + (v == null ? '—' : fmt(v)) + '</td>';
        }).join('') + '</tr>';
      }).join('') + '</tbody></table>';
  }

  /* Botones de zona (hacen de pestañas): items [{ id, label, count }]; count = elementos en la zona. */
  function zones(items, active) {
    return items.map(function (z) {
      var on = z.id === active;
      return '<button type="button" class="cte-zb' + (on ? ' is-on' : '') + '" role="tab" aria-selected="' + on + '" data-cte-tab="' + esc(z.id) + '"' +
        (z.count ? ' aria-label="' + esc(z.label) + ' (' + z.count + (z.count === 1 ? ' elemento' : ' elementos') + ')"' : '') + '>' + esc(z.label) +
        (z.count ? '<span class="cte-zb__n" aria-hidden="true">' + z.count + '</span>' : '') + '</button>';
    }).join('');
  }

  /* Botones de fuente escritos con su tipografía. fonts: [{ key, name, weight, previewFamily, quick }]. */
  function fonts(list, selected, showAll) {
    return list.map(function (f) {
      var on = f.key === selected;
      return '<button type="button" class="cte-font' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-cte-fontkey="' + esc(f.key) + '"' +
        (!f.quick && !showAll && !on ? ' hidden' : '') + ' style="font-family:' + esc(f.previewFamily) + ';font-weight:' + f.weight + '">' + esc(f.name) + '</button>';
    }).join('');
  }

  /* Muestras rápidas de color del texto. */
  function textColors(list, selected) {
    return list.map(function (c) {
      var on = c.toUpperCase() === String(selected || '').toUpperCase();
      return '<button type="button" class="cte-tsw' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" aria-label="' + esc(c) +
        '" title="' + esc(c) + '" data-cte-tcolor="' + esc(c) + '" style="background:' + esc(c) + '"></button>';
    }).join('');
  }

  /* items: [{ layer, name, outside, selected }] en orden de lista (arriba = delante). */
  function layers(items) {
    return items.map(function (it) {
      var l = it.layer, name = esc(it.name);
      var thumb = l.type === 'image' ? '<img src="' + esc(l.thumb) + '" alt="">' : '<span aria-hidden="true">T</span>';
      return '<li class="cte-layer' + (it.selected ? ' is-sel' : '') + (l.hidden ? ' is-hidden' : '') + (it.outside ? ' is-out' : '') + '" data-id="' + l.id + '">' +
        '<button type="button" class="cte-layer__grip" data-cte-grip aria-label="Cambiar el orden de ' + name + ' (flechas arriba y abajo)">⋮⋮</button>' +
        '<span class="cte-layer__thumb">' + thumb + '</span>' +
        '<button type="button" class="cte-layer__name" data-cte-pick aria-pressed="' + it.selected + '">' + name +
        (it.outside ? '<small>Se sale de la impresión</small>' : '') + '</button>' +
        '<button type="button" class="cte-layer__icon" data-cte-eye aria-pressed="' + !!l.hidden + '" aria-label="' + (l.hidden ? 'Mostrar ' : 'Ocultar ') + name + '">' +
        (l.hidden ? IO.ICON_EYE_OFF : IO.ICON_EYE) + '</button>' +
        '<button type="button" class="cte-layer__icon" data-cte-del aria-label="Borrar ' + name + '">' + IO.ICON_TRASH + '</button>' +
        /* móvil: subir / bajar con botones en vez de arrastrar (en escritorio no se ven) */
        '<button type="button" class="cte-layer__icon cte-layer__mv" data-cte-lmove="-1" aria-label="Subir ' + name + ' (más delante)">↑</button>' +
        '<button type="button" class="cte-layer__icon cte-layer__mv" data-cte-lmove="1" aria-label="Bajar ' + name + ' (más detrás)">↓</button></li>';
    }).join('');
  }

  /* Tabla de medidas por talla: una fila por talla y, dentro, cada impresión con su tamaño de cobro en esa talla.
     opts: { sleeve, billing (talla de cobro), name(impresión) → nombre visible } */
  function scaleRows(rows, opts) {
    return rows.map(function (r) {
      var n = r.impresiones.length;
      return r.impresiones.map(function (p, i) {
        var cls = (r.ref ? 'is-ref' : '') + (p.excede || p.pasaHombro || p.superaTalla ? ' is-over' : '') + (i === n - 1 ? ' is-last' : '');
        var size = p.ancho == null ? '<span class="cte-muted">Sin capas</span>' : fmt(p.ancho) + ' × ' + fmt1(p.alto) +
          (p.excede ? '<small>Supera ' + (opts.sleeve ? '10×10' : '40×50') + '</small>' : '') +
          (p.superaTalla && !p.excede ? '<small>Supera el máximo de la talla</small>' : '') +
          (p.ajuste && !p.excede ? '<small class="cte-amber">−' + fmt(p.ajuste.cm) + ' cm → ' + M.sizeLabel(p.ajuste.tamano) + '</small>' : '') +
          (p.fueraAnchoUtil ? '<small class="cte-amber">Fuera del ancho útil</small>' : '');
        var dist = p.distancia == null ? '<span class="cte-muted">Sin indicar</span>' : fmt(p.distancia) + ' cm';
        if (p.pasaHombro) dist += '<small>Pasa el hombro</small>';
        var dx = opts.sleeve ? 'Centrada' : (p.desplazamiento === 0 ? '0' : window.CorexTextilDraw.signed(p.desplazamiento) + ' cm');
        return '<tr class="' + cls + '"' + (r.ref ? ' aria-current="true"' : '') + '>' +
          (i === 0 ? '<th scope="rowgroup" rowspan="' + n + '">' + esc(r.talla) + (r.ref ? ' <small>ref.</small>' : '') + '</th>' : '') +
          '<td>' + esc(opts.name ? opts.name(p) : p.nombre) + (p.tamano && !opts.sleeve ? ' <span class="cte-muted">· ' + M.sizeLabel(p.tamano) + '</span>' : '') +
          (r.talla === opts.billing && p.tamano ? '<small>Se cobra</small>' : '') + '</td>' +
          '<td data-l="Ancho × alto">' + size + '</td><td data-l="' + esc(opts.distLabel || 'Distancia') + '">' + dist + '</td><td data-l="Desplazamiento">' + dx + '</td></tr>';
      }).join('');
    }).join('');
  }

  window.CorexTextilUI = { colors: colors, sizes: sizes, guide: guide, zones: zones, fonts: fonts, textColors: textColors, layers: layers, scaleRows: scaleRows };
})();
